














































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import {
  BModal,
  BButton,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  BSpinner,
  BTable,
  BCard,
  BCardBody,
} from 'bootstrap-vue'
import moment from 'moment'

interface Site {
  id: string
  libelle: string
}

interface Intervenant {
  id: string
  nom: string
  prenom: string
  mission: string
}

interface TypeRdv {
  id: string
  libelle: string
  duree: number
  visio: string
}

interface Creneau {
  heure: string
  idsAgendasDisponibles: string[]
}

interface Disponibilite {
  dateJour: string
  jourFormatted: string
  creneaux: Creneau[]
}

@Component({
  components: {
    BModal,
    BButton,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BSpinner,
    BTable,
    BCard,
    BCardBody
  }
})
export default class CreateMeetingDialog extends Vue {
  @Prop({ required: true, type: Boolean })
  visible!: boolean

  @Prop({ required: false, type: String, default: '' })
  beneficiaireId!: string

  // Data
  activeIndex = 0
  phoneNumber = ''
  siteId: string | null = null
  intervenantId = ''
  typeRdvId = ''
  horaire = ''
  idsAgendasDisponibles: string[] = []
  meetingCreated = false
  meetingId: string | null = null
  createLoading = false
  clickCount = 0

  dateDebut = this.getFormattedDate(new Date())
  dateFin = this.getFormattedDate(this.getDatePlusMonths(new Date(), 2))

  // API Data
  sites: Site[] = []
  intervenants: Intervenant[] = []
  typesRDV: TypeRdv[] = []
  disponibilites: Disponibilite[] = []

  // Loading states
  isLoadingSites = false
  isLoadingIntervenants = false
  isLoadingTypesRDV = false
  isLoadingDisponibilites = false

  // Options
  noAvailabilityMessage = ''
  isMeetingIAEnabled = false

  steps = [
    { label: 'Vérification du téléphone' },
    { label: 'Sélection du site' },
    { label: "Sélection de l'intervenant" },
    { label: 'Type de rendez-vous' },
    { label: 'Date et heure' },
    { label: 'Validation' },
  ]

  typeRdvFields = [
    { key: 'libelle', label: 'Type' },
    { key: 'duree', label: 'Durée (min)' },
    { key: 'actions', label: '' }
  ]

  get isVisible() {
    return this.visible
  }

  set isVisible(value: boolean) {
    this.$emit('update:visible', value)
  }

  get phoneNumberValid() {
    return /^\d{10}$/.test(this.phoneNumber)
  }

  get sitesOptions() {
    return this.sites
  }

  get canLoadMore() {
    return this.clickCount < 2
  }

  get intervenantDisplay() {
    const intervenant = this.intervenants.find(i => i.id === this.intervenantId)
    if (!intervenant) return ''
    return `${intervenant.nom} ${intervenant.prenom} (${intervenant.mission})`
  }

  get typeRdvDisplay() {
    const typeRdv = this.typesRDV.find(t => t.id === this.typeRdvId)
    if (!typeRdv) return ''
    return `${typeRdv.libelle} (${typeRdv.duree} minutes)`
  }

  get typeRdvIsVisio() {
    const typeRdv = this.typesRDV.find(t => t.id === this.typeRdvId)
    return typeRdv?.visio === 'O'
  }

  get siteDisplay() {
    const site = this.sites.find(s => s.id === this.siteId)
    return site?.libelle || ''
  }

  async created() {
    await this.loadSites()
    await this.loadTenantOptions()
  }

  @Watch('siteId')
  async onSiteChanged() {
    if (this.siteId) {
      await this.loadIntervenants()
    }
  }

  @Watch('intervenantId')
  async onIntervenantChanged() {
    if (this.intervenantId) {
      await this.loadTypesRDV()
    }
  }

  @Watch('typeRdvId')
  async onTypeRdvChanged() {
    if (this.typeRdvId) {
      await this.loadDisponibilites()
    }
  }

  async loadSites() {
    this.isLoadingSites = true
    try {
      this.sites = await this.$http.ptfBeneficiaire.meetings.getSites(this.beneficiaireId)
    } catch (error) {
      console.error('Erreur lors du chargement des sites', error)
    } finally {
      this.isLoadingSites = false
    }
  }

  async loadIntervenants() {
    if (!this.siteId) return
    this.isLoadingIntervenants = true
    try {
      this.intervenants = await this.$http.ptfBeneficiaire.meetings.getIntervenants(this.siteId)
    } catch (error) {
      console.error('Erreur lors du chargement des intervenants', error)
    } finally {
      this.isLoadingIntervenants = false
    }
  }

  async loadTypesRDV() {
    if (!this.siteId || !this.intervenantId) return
    this.isLoadingTypesRDV = true
    try {
      this.typesRDV = await this.$http.ptfBeneficiaire.meetings.getTypesRDV(
        this.siteId,
        this.intervenantId
      )
    } catch (error) {
      console.error('Erreur lors du chargement des types de RDV', error)
    } finally {
      this.isLoadingTypesRDV = false
    }
  }

  async loadDisponibilites() {
    if (!this.siteId || !this.intervenantId || !this.typeRdvId) return
    this.isLoadingDisponibilites = true
    try {
      this.disponibilites = await this.$http.ptfBeneficiaire.meetings.getDisponibilites(
        this.siteId,
        this.intervenantId,
        this.typeRdvId,
        this.dateDebut,
        this.dateFin
      )
    } catch (error) {
      console.error('Erreur lors du chargement des disponibilités', error)
    } finally {
      this.isLoadingDisponibilites = false
    }
  }

  async loadTenantOptions() {
    try {
      const options = await this.$http.ptfBeneficiaire.meetings.getTenantOptions()
      this.noAvailabilityMessage = options.find((o: any) => o.key === 'NoDisponibilitiesMessage')?.value || ''
      this.isMeetingIAEnabled = options.find((o: any) => o.key === 'MeetingIAEnabled')?.value === 'true'
    } catch (error) {
      console.error('Erreur lors du chargement des options', error)
    }
  }

  verifyPhoneNumber() {
    // Validation déjà gérée par le computed phoneNumberValid
  }

  goToStep(index: number) {
    this.activeIndex = index
  }

  chooseIntervenant(intervenantId: string) {
    this.intervenantId = intervenantId
  }

  chooseTypeRDV(typeRdvId: string) {
    this.typeRdvId = typeRdvId
  }

  chooseHoraire(jour: string, horaire: string, idsAgendasDisponibles: string[]) {
    this.horaire = this.formatDateTimeForAPI(jour, horaire)
    this.idsAgendasDisponibles = idsAgendasDisponibles
  }

  async validateMeeting() {
    this.createLoading = true
    try {
      const meetingData = {
        siteId: this.siteId,
        intervenantId: this.intervenantId,
        prestationId: this.typeRdvId,
        startDateTime: this.horaire,
        possiblesIntervenants: this.idsAgendasDisponibles,
        visio: this.typeRdvIsVisio,
        telephone: this.phoneNumber,
        userId: this.beneficiaireId
      }

      const idMeeting = await this.$http.ptfBeneficiaire.meetings.create(meetingData)
      this.meetingId = idMeeting

      this.$bvToast.toast('Votre rendez-vous a bien été créé !', {
        title: 'Rendez-vous validé',
        variant: 'success',
        solid: true
      })

        this.$emit('created')
      this.closeDialog()

    //   if (this.isMeetingIAEnabled) {
    //     this.meetingCreated = true
    //     this.goToStep(6)
    //   } else {
    //     this.$emit('created')
    //     this.closeDialog()
    //   }
    } catch (error: any) {
      this.$bvToast.toast(
        'Nous ne sommes pas parvenu a créer votre rendez-vous. Veuillez réessayer.',
        {
          title: 'Erreur',
          variant: 'danger',
          solid: true
        }
      )
    } finally {
      this.createLoading = false
    }
  }

  navigateToPrepareMeetingAI() {
    const encodedTypeRDV = btoa(unescape(encodeURIComponent(this.typeRdvDisplay)))
    const encodedIdMeeting = btoa(unescape(encodeURIComponent(this.meetingId || '')))
    const encodedTelBeneficiaire = btoa(unescape(encodeURIComponent(this.phoneNumber)))
    
    this.closeDialog()
    this.$router.push({
      name: 'prepare-meeting-ai',
      query: {
        typeRDV: encodedTypeRDV,
        idMeeting: encodedIdMeeting,
        telBeneficiaire: encodedTelBeneficiaire
      }
    })
  }

  showMoreDisponibilities() {
    if (this.clickCount < 2) {
      this.clickCount++
      const currentEndDate = this.getDatePlusMonths(new Date(), this.clickCount + 1)
      this.dateFin = this.getFormattedDate(currentEndDate)
      this.loadDisponibilites()
    }
  }

  formatDateTimeForAPI(dateStr: string, timeStr: string): string {
    const [year, month, day] = dateStr.split('-').map(Number)
    const [hours, minutes] = timeStr.split(':').map(Number)
    const date = new Date(year, month - 1, day, hours, minutes)
    return date.toISOString()
  }

  formatDateTime(isoString: string): string {
    if (!isoString) return ''
    return moment(isoString).locale('fr').format('dddd D MMMM YYYY à HH:mm')
  }

  formatJourDate(dateStr: string): string {
    if (!dateStr) return ''
    const formatted = moment(dateStr).locale('fr').format('dddd D MMMM YYYY')
    return formatted.charAt(0).toUpperCase() + formatted.slice(1)
  }

  getFormattedDate(date: Date): string {
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  getDatePlusMonths(date: Date, months: number): Date {
    const newDate = new Date(date)
    newDate.setMonth(newDate.getMonth() + months)
    return newDate
  }

  resetForm() {
    this.activeIndex = 0
    this.phoneNumber = ''
    this.siteId = null
    this.intervenantId = ''
    this.typeRdvId = ''
    this.horaire = ''
    this.idsAgendasDisponibles = []
    this.meetingCreated = false
    this.meetingId = null
    this.clickCount = 0
  }

  closeDialog() {
    this.isVisible = false
    this.resetForm()
    this.$emit('reset')
  }

  onHide() {
    this.closeDialog()
  }
}
